/*
    Errors held in common to support cases where
    the UI needs to react in a very specific way
    to a particular exception
*/

export enum AuthError {
    VerificationDeadlinePassed = 'Verification Deadline Passed'
}
